export const SET_LOADING_DATA = '@product/SET_LOADING_DATA';

export const GET_ALL_REQUEST = '@product/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@product/GET_ALL_SUCCESS';

export const GET_FILTER_REQUEST = '@product/GET_FILTER_REQUEST';
export const GET_FILTER_SUCCESS = '@product/GET_FILTER_SUCCESS';

export const GET_BY_ID_REQUEST = '@product/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@product/GET_BY_ID_SUCCESS';

export const GET_LIST_PRODUCT_REQUEST = '@product/GET_LIST_PRODUCT_REQUEST';
export const GET_LIST_PRODUCT_SUCCESS = '@product/GET_LIST_PRODUCT_SUCCESS';

export const GET_ALL_PROMOTION_KIT_REQUEST = '@product/GET_ALL_PROMOTION_KIT_REQUEST';
export const GET_ALL_PROMOTION_KIT_SUCCESS = '@product/GET_ALL_PROMOTION_KIT_SUCCESS';

export const SET_PAGE = '@product/SET_PAGE';
export const SET_ROWS_COUNT = '@product/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE = '@product/SET_ROWS_PER_PAGE';
export const SET_ROWS_ORIENTATION = '@product/SET_ROWS_ORIENTATION';
export const SET_ORDER = '@product/SET_ORDER';
export const SET_ORDERBY = '@product/SET_ORDERBY';

export const SET_SWITCHES_FILTERS = '@product/SET_SWITCHES_FILTERS';

export const SEARCH = '@product/SEARCH';

export const SET_LOADING_COUNT = '@product/SET_LOADING_COUNT';
export const CLEAR_LIST_PRODUCT = '@product/CLEAR_LIST_PRODUCT';
